import { useApi } from '@/src/store/api.context';
import { getCurrentBreadCrumbs } from '@/src/utils/breadcrumbs.utils';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { RoutePath } from '../RoutePath';
import { isAITeammatePathname } from '@/src/utils/url.utils';

export const useActiveRouteDetails = () => {
  const location = useLocation();
  const history = useHistory();
  const { eventsApi } = useApi();
  const breadcrumbs = getCurrentBreadCrumbs(history.location.pathname);
  const enableBreadCrumb = breadcrumbs.length < 2;

  const fetchEventAndRedirect = async () => {
    const urlSearchParams = new URLSearchParams(location.search);
    const tcOrderId = urlSearchParams.get('tcOrderId');
    if (tcOrderId) {
      const eventResponse = await eventsApi.getEventByOrderId(tcOrderId);
      const eventId = eventResponse.event.name;
      history.push(`/events/${eventId}`);
    }
  };

  useEffect(() => {
    void fetchEventAndRedirect();
  }, []);

  return {
    activeRoute: location.pathname,
    breadcrumbs,
    isHome: enableBreadCrumb,
    isAiTeammateGameView: isAITeammatePathname(location.pathname),
    isCreateJamProfile: location.pathname === RoutePath.JAM_PROFILE_CREATE,
  };
};
